import { useMemo } from "react";

import { useAccount } from "../../services/settings/hooks/useAccount";
import { shouldShowNewSubscriptions } from "../../services/user-subscriptions/utils";

export const useShouldShowNewSubscriptions = (): boolean => {
  const { accountSettings } = useAccount();

  return useMemo(
    () => shouldShowNewSubscriptions(accountSettings),
    [accountSettings],
  );
};
